module.exports = __webpack_public_path__ + "static/170-4d2a18f8033adbb572b537b41878c66c.jpg";